import {
  WIDGET_FETCH_ERROR,
  WIDGET_FETCH_START,
  WIDGET_FETCH_SUCCESS,
  WIDGET_FIELD_OPTIONS,
  WIDGET_RESET_DATA,
  WIDGET_RESET_STATE,
} from 'shared/constants/ActionTypes';
import {UiWiseWidgetState} from 'shared/constants/UiWiseConst';

const widgetRuducerInitialState = {
  widgetDataById: {}, // Optional: store specific data for tables/forms here
  widgetStateById: {}, // Success flags, loading states, etc.
  widgetFieldOptionsById: {}, // Optional: store specific Field Options for widget here
};

const updateWidgetState = (state, widgetId, widgetStatus) => {
  return {
    ...state,
    widgetStateById: {
      ...state.widgetStateById,
      [widgetId]: widgetStatus,
    },
  };
};

const updateWidgetData = (state, widgetId, widgetData) => {
  return {
    ...state,
    widgetDataById: {
      ...state.widgetDataById,
      [widgetId]: widgetData,
    },
  };
};

const WidgetReducer = (state = widgetRuducerInitialState, action) => {
  const {type, widgetId, payload} = action;

  switch (type) {
    case WIDGET_FETCH_START:
      // No changes to the Data to keep the Table data intact
      return updateWidgetState(state, widgetId, UiWiseWidgetState.LOADING);

    case WIDGET_FETCH_SUCCESS: {
      const newState = updateWidgetState(
        state,
        widgetId,
        UiWiseWidgetState.SUCCESS,
      );
      return updateWidgetData(newState, widgetId, payload);
    }

    case WIDGET_FETCH_ERROR:
      return updateWidgetState(state, widgetId, UiWiseWidgetState.ERROR);

    case WIDGET_RESET_STATE: {
      const nextState = {...state.widgetStateById};
      delete nextState[widgetId]; // Total removal
      return {
        ...state,
        widgetStateById: nextState,
      };
    }

    case WIDGET_RESET_DATA: {
      const nextData = {...state.widgetDataById};
      delete nextData[widgetId]; // Total removal

      const nextOptions = {...state.widgetFieldOptionsById};
      delete nextOptions[widgetId]; // Total removal

      return {
        ...state,
        widgetDataById: nextData,
        widgetFieldOptionsById: nextOptions,
      };
    }

    case WIDGET_FIELD_OPTIONS: {
      const {fieldName, options} = payload;
      return {
        ...state,
        widgetFieldOptionsById: {
          ...state.widgetFieldOptionsById,
          [widgetId]: {
            ...(state.widgetFieldOptionsById[widgetId] || {}),
            [fieldName]: options,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default WidgetReducer;
